import {
  states,
  countries,
  Canada,
  expandedStates,
  Mexico,
  US,
} from "../../../../constants/data";
import Styles from "../editScreenStyles.module.css";
import { yesNo } from "../../../../constants/options";

function PropertyEdit({
  fields,
  utilities,
  updateClicked,
  cancelClicked
}) {

  const {
    createToggleInput,
    createNoLabelInput,
    createNoLabelSelect,
    createCustomLabelTextArea
  } = utilities;

  return (
    <div>
      <div className={Styles.title}>Property Damage</div>
      <div className={Styles.column}>
        {createToggleInput(fields.damageToProperty, "100%", yesNo, true)}
    
        {fields.damageToProperty.value && (
          <div className={Styles.row}>
            {createToggleInput(fields.whoOwnsProperty, "100%", yesNo, true)}
          </div>
        )}
        {fields.damageToProperty.value && fields.whoOwnsProperty.value && (
          <div className={Styles.hiddenDiv}>
            <div className={Styles.row}>
              {createNoLabelInput(fields.propertyOwnerFirstName, "100%", Styles.input)}
              {createNoLabelInput(fields.propertyOwnerLastName, "100%", Styles.input)}
              {createNoLabelInput(fields.propertyOwnerAddress, "100%", Styles.input)}
            </div>
            <div className={Styles.row}>
              {createNoLabelInput(fields.propertyOwnerCity, "100%", Styles.input)}
              {fields.propertyOwnerCountry.value === US.name && (
                createNoLabelSelect(fields.propertyOwnerState, "15rem", states, Styles.select, "Select a State")
              )}
              {fields.propertyOwnerCountry.value === Mexico.name && (
                createNoLabelInput(fields.propertyOwnerState, "15rem", Styles.input)
              )}
              {fields.propertyOwnerCountry.value === Canada.name && (
                createNoLabelSelect(
                  fields.propertyOwnerState,
                  "15rem",
                  expandedStates
                    .filter(state => state.country.code === Canada.code)
                    .map(state => state.state),
                  Styles.select,
                  "Select a Province"
                  )
              )}
              {createNoLabelInput(fields.propertyOwnerCounty, "100%", Styles.input)}
            </div>
            <div className={Styles.row}>
              {createNoLabelInput(fields.propertyOwnerZipcode, "100%", Styles.input)}
              {createNoLabelSelect(
                fields.propertyOwnerCountry,
                "100%",
                countries.map(country => country.name),
                Styles.select
              )}
              {createNoLabelInput(fields.propertyOwnerPhone, "100%", Styles.input, "tel")}
            </div>

            <div className={Styles.column}>
              {createCustomLabelTextArea(fields.propertyOwnerDescribeProperty, "100%", Styles.textarea, Styles.blockLabel)}
              {createCustomLabelTextArea(fields.propertyOwnerDamageProperty, "100%", Styles.textarea, Styles.blockLabel)}
            </div>
            <div className={Styles.column}>
              <p className={Styles.blockLabel}>
                Where can the damaged property be seen?
              </p>
              <div className={Styles.row}>
                {createNoLabelInput(fields.propertyLocationAddress, "100%", Styles.input)}
                {createNoLabelInput(fields.propertyLocationCity, "100%", Styles.input)}
              </div>
              <div className={Styles.row}>
                {createNoLabelSelect(
                  fields.propertyLocationState,
                  "100%",
                  states,
                  Styles.select,
                  "Select a state"
                )}
                {createNoLabelInput(fields.propertyLocationZip, "100%", Styles.input)}
              </div>
            </div>
          </div>
        )}

        <div className={Styles.buttons}>
          <button
            type="button"
            className={Styles.button}
            onClick={cancelClicked}
          >
            Cancel
          </button>
          <button
            type="button"
            className={Styles.button}
            onClick={updateClicked}
          >
            Update
          </button>
        </div>
      </div>
    </div>
  );
}

export default PropertyEdit;
